module.exports = __webpack_public_path__ + "img/header-14.caacb384.png";